import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
export var PisteFeedbackFormSchema = new SimpleSchema({
    pisteId: {
        type: String,
        autoform: {
            type: "hidden"
        }
    },
    pisteName: {
        type: String,
        autoform: {
            type: "hidden"
        }
    },
    knewThePiste: {
        type: Boolean,
        autoform: {
            type: "boolean-radios",
            trueLabel: "Oui",
            falseLabel: "Non"
        },
        label: "Connaissais-tu cette piste d'\xe9tudes avant de venir sur INSPIRE ?"
    },
    consideredThePiste: {
        optional: true,
        type: Boolean,
        autoform: {
            type: "boolean-radios",
            trueLabel: "Oui",
            falseLabel: "Non"
        },
        label: "Envisageais-tu d\xe9j\xe0 cette piste d'\xe9tudes avant de venir sur INSPIRE ?"
    },
    createdAt: {
        optional: true,
        type: Date,
        autoValue: function autoValue() {
            if (this.isInsert) {
                return new Date();
            }
            if (this.isUpsert) {
                return {
                    $setOnInsert: new Date()
                };
            }
            this.unset();
        }
    }
});
export var PisteFeedbackSchema = new SimpleSchema({
    userId: {
        type: String
    }
}).extend(PisteFeedbackFormSchema);
